import './LinkWithImage.scss'

import React, { ReactNode } from 'react'
import classNames from 'classnames'

import LinkWithLocale from './LinkWithLocale'
import Thumbnail from './Thumbnail'

import { PosterType } from '../constants/enums'

export interface Props {
  link: string
  imageUrl: string
  alt: string
  className?: string
  posterType?: PosterType
  isShowLetterbox?: boolean
  isNew?: boolean
  nativeLink?: boolean
  videoDuration?: number
  progressRatio?: number
  children?: ReactNode
}

export default function LinkWithImage({
  link,
  imageUrl,
  alt,
  className,
  posterType,
  isShowLetterbox,
  isNew,
  nativeLink = false,
  videoDuration,
  progressRatio,
  children,
}: Props) {
  return (
    <LinkWithLocale nativeLink={nativeLink} className={classNames('LinkWithImage', className)} to={link}>
      <Thumbnail
        imageUrl={imageUrl}
        alt={alt}
        posterType={posterType}
        isShowLetterbox={isShowLetterbox}
        isNew={isNew}
        videoDuration={videoDuration}
        progressRatio={progressRatio}
      />
      {children}
    </LinkWithLocale>
  )
}
